import Service from "../service";
var PageType;
(function (PageType) {
    PageType["Article"] = "article";
})(PageType || (PageType = {}));
class DataLayerService extends Service {
    constructor(config, context) {
        super("DataLayer", context);
        if (!config) {
            throw new Error("Missing data layer configuration");
        }
        this.configuration = config;
        this.logger.logInfo(`Building data layer ${this.configuration.name} - ${this.configuration.id}`);
        this.dataLayer = this.buildDataLayer(this.configuration);
        this.logger.logInfo("Data layer ready");
    }
    buildDataLayer(config) {
        this.logger.logInfo(`Setting up data layer with ${Object.entries(config.data).length} keys`);
        const dl = {};
        for (const [key, value] of Object.entries(config.data)) {
            if (typeof value !== "undefined" && typeof value.get === "function") {
                Object.defineProperty(dl, key, {
                    get: value.get,
                    enumerable: true,
                });
                this.logger.logDebug(`Setting up data layer variable ${key}: ${value.name}`);
            }
            else {
                this.logger.logWarn(`Data layer key ${key} does not have a getter`);
            }
        }
        return dl;
    }
}
export { DataLayerService, PageType };
//# sourceMappingURL=datalayer.js.map